export default {
  model: {
    'activeStorage/attachment': 'Attachment',
    'role': '角色',
    'customerSource': '客户来源',
    'user': '用户',
    'userOauthIdentityAccount': '微信账号',
    'usersRole': 'Users role',
    'application': '应用管理',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'operationRecord': '操作日志',
    'channel': '渠道',
    'customerLevel': '客户级别',
    'customerKind': '客户类型',
    'customerConnection': '客户对接方式',
    'customerTag': '客户标签',
    'customerTransaction': '交易方式',
    'customerBusinessModel': '业务模式',
    'productStyle': '产品风格',
    'saleChannel': '销售渠道',
    'customer': '客户',
    'customerJushuitanOrderRelation': '聚水潭订单关联',
    'followKeyItem': '关键事项',
    'taskAssignment': '任务安排',
    'followRecord': '跟进记录',
    'customerChannel': '客户渠道',
    'customerBackgroundCheck': '客户背调',
    'jushuitanShop': '聚水潭店铺',
    'jushuitanOrder': '聚水潭订单',
    'jushuitanAfterSale': '聚水潭售后',
    'notification': '通知',
    'memo': '备忘录',
    'customReport': '数据分析',
    'task': '任务',
    'jushuitanInventoryOut': '聚水潭出库单',
    'paymentAccount': '收款账号',
    'paymentAllocation': 'Payment allocation',
    'payment': '收款明细',
    'adjustment': '应收调整',
    'paymentReminder': '收款提醒',
    'salesLineItem': '销售订单商品',
    'salesOrderAllocation': 'Sales order allocation',
    'afterSaleAllocation': '售后已收金额分配',
    'salesOrder': '销售订单',
    'feige/product': 'Product',
    'workReport': '工作日报',
    'reports/receivable': '应收汇总',
    'reports/commissionSource': '销售提成源表',
    'performanceGoal': '业绩目标',
    'team': '团队',
    'operationLog': '操作日志',
    'billSendRecord': '账单发送记录',
    'banner': '轮播图',
    'customPage': '自定义页面',
    'hotWord': '搜索热词',
    'page': '静态页面',
    'presetPage': '静态页面',
    'profile': 'Profile',
    'roleCore/role': '角色',
    'staticPage': '静态页面',
    'userGroup': '业务组',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '管理员',
      business_executive: '业务主管',
      salesman: '业务员',
      channel_business_executive: '渠道业务主管',
      finance: '财务',
      customer_service: '客服',
      finance_manager: '财务主管',
      custom: '自定义角色',
      merchandiser: '跟单员',
    },
    customPermissions: '自定义权限',
  },
  'customerSource': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '名称',
    isBlock: '已冻结',
    email: '邮箱',
    roleId: '角色',
    creatorId: 'Creator',
    phone: '手机号码',
    avatar: '头像',
    role: '角色',
    creator: 'Creator',
    customerSourceIds: '客户来源',
    customerSources: '客户来源',
    relatedUserIds: '关联业务员',
    relatedUsers: '关联业务员',
    customerCapacityLimit: '客户容量上限',
  },
  'userOauthIdentityAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
  },
  'usersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: 'Role',
    userId: 'User',
    role: '角色',
    user: '用户',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    shareImage: '分享图片',
    logo: 'Logo',
    monthlyReportReceivers: '报告接收人',
    purpleShopIds: '紫队店铺ID',
    leaderboardScrollInterval: '大屏滚动间隔',
    customShopIds: '定制业务店铺ID',
    fengPeiShanUserId: '冯佩珊用户ID',
    fengPeiShanShopIds: '冯佩珊店铺ID',
    dengZhengYaoUserId: '邓正瑶用户ID',
    dengZhengYaoShopIds: '邓正瑶店铺ID',
    luoXingYiUserId: '骆幸仪用户ID',
    teamLeaderCustomerLimit: '组长客户容量上限',
    teamMemberCustomerLimit: '组员客户容量上限',
    dateExcludedShopIds: '日期排除店铺ID',
    dateExcludedCutoffDate: '日期排除截止日期',
    customerPoolOpenDays: '流转池开放日',
    customerPoolOpenFromHour: '流转池开放起始小时',
    customerPoolOpenToHour: '流转池开放结束小时',
    customerPoolDailyClaimLimit: '每人每日认领上限',
    customerPoolOwnershipRestrictionMonths: '原归属人认领限制月数',
    customerPoolFollowupHours: '认领后首次跟进期限（小时）',
    customerPoolFollowupWarningLeadHours: '跟进到期提醒提前小时',
    customerPoolNewRecordNoFollowDays: '新录入无跟进释放天数',
    customerPoolNewCustomerNoFollowDays: '新客无跟进释放天数',
    customerPoolNewCustomerNoOrderDays: '新客无成交释放天数',
    customerPoolOldCustomerNoFollowDays: '老客无跟进释放天数',
    customerPoolOldCustomerNoRepurchaseDays: '老客无复购释放天数',
    customerPoolCapacityWarningRatio: '容量预警比例',
    customerPoolReleaseWarningLeadDays: '释放预警提前天数',
    posterImage: '海报图片',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    url: '内容',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operatableType: '操作对象类型',
    operatableId: '操作对象ID',
    operatorType: 'Operator type',
    operatorId: 'Operator',
    ipAddress: 'IP地址',
    operator: '操作者',
    operatable: '操作对象',
    operationDescription: '操作描述',
    requestPath: '请求路径',
    requestMethod: '请求方法',
    requestParams: '请求数据',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'channel': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    orderColumn: 'Order column',
    orderColumns: {
      shop_id: 'Shop',
      buyer_id: 'Buyer',
      open_id: 'Open',
      drp_co_id_from: 'Drp co id from',
    },
  },
  'customerLevel': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    remindDays: '提醒天数',
    description: '描述',
    yearlyMinOrderAmount: '年度最低采购额',
    yearlyMaxOrderAmount: '年度最高采购额',
  },
  'customerKind': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'customerConnection': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'customerTag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'customerTransaction': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    stages: '阶段比例',
  },
  'customerBusinessModel': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'productStyle': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'saleChannel': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'customer': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    userId: '业务员',
    customerLevelId: '客户级别',
    customerSourceId: '客户来源',
    customerKindId: '客户类型',
    customerConnectionId: '客户对接方式',
    customerTransactionId: '交易方式',
    createDate: '创建日期',
    manager: '决策人',
    phone: '电话',
    customerLevel: '客户级别',
    customerLevelFixed: '固定客户级别',
    tradeHeat: '交易热度',
    last7DayOrderQty: '近7天订单件数',
    last7DayOrderAmount: '近7天订单金额',
    last30DayOrderQty: '近30天订单件数',
    last30DayOrderAmount: '近30天订单金额',
    lastMonthOrderQty: '上月订单件数',
    lastMonthOrderAmount: '上月订单金额',
    user: '业务员',
    customerSource: '客户来源',
    customerKind: '客户类型',
    customerConnection: '客户对接方式',
    customerTags: '客户标签',
    customerTransaction: '交易方式',
    customerBusinessModels: '业务模式',
    productStyles: '产品风格',
    saleChannels: '销售渠道',
    customerBusinessModelIds: '业务模式',
    productStyleIds: '产品风格',
    saleChannelIds: '销售渠道',
    customerTagIds: '客户标签',
    needSupplementInformation: 'Need supplement information',
    lastFollowRecordOfUserFollowedAt: '最新跟进日期',
    assignToUser: '分配给',
    restAmount: '欠款余额',
    annualStatusList: '系统标签',
    annualStatusManual: 'Annual status manual',
    newCustomerInCurrentYear: '当前年份新客',
    poolReleasedReason: 'Pool released reason',
    poolReleasedUserId: 'Pool released user',
    poolReleasedUser: 'Pool released user',
    poolEnteredAt: 'Pool entered at',
    poolDays: 'Pool days',
    latestEffectiveFollowedAt: 'Latest effective followed at',
    latestOrderedOn: 'Latest ordered on',
    address: '地址',
    wechat: '微信',
    hasProductionCapacity: '生产能力',
    hasDesignCapability: '设计能力',
    pricePreference: '价格偏好',
    inquiryContent: '询盘内容',
    brand: '品牌',
    salesAbility: '销售能力',
    customerJushuitanOrderRelations: '聚水潭订单关联',
    followRecords: '跟进记录',
    files: '附件',
    negotiationForm: 'Negotiation form',
  },
  'customerJushuitanOrderRelation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    jushuitanOrderKey: 'Jushuitan order key',
    jushuitanOrderForeignKey: '关联类型',
    jushuitanOrderForeignKeys: {
      drp_co_id_from: '分销商ID',
      open_id: 'OpenID',
      buyer_id: 'BuyerID',
      shop_id: '店铺ID',
      shop_buyer_id: 'Shop buyer',
    },
    jushuitanOrderForeignKeyValue: '关联值',
    customer: '客户',
  },
  'followKeyItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    isEffectiveFollow: '是否计入有效跟进',
  },
  'taskAssignment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    assigneeId: '执行人',
    state: '状态',
    states: {
      pending: '待处理',
      processing: '处理中',
      completed: '已完成',
    },
    reply: '回复',
    taskTitle: 'Task title',
    taskId: 'Task',
    assignee: '执行人',
    customersCount: 'Customers count',
    followedCustomersCount: 'Followed customers count',
    followRatio: '触达率',
    followRecords: '跟进记录',
    followedCustomers: 'Followed customers',
    unfollowedCustomers: 'Unfollowed customers',
  },
  'followRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    customerId: '跟进对象',
    userId: '跟进人',
    followedAt: '跟进时间',
    taskAssignmentId: '任务',
    customer: '客户',
    content: '跟进内容',
    user: '用户',
    media: '附件',
    followKeyItemIds: '关键事项',
    followKeyItems: '关键事项',
    taskAssignment: '任务安排',
  },
  'customerChannel': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    no: 'No',
    channelId: '渠道',
    customerId: '客户',
    channel: '渠道',
    customer: '客户',
  },
  'customerBackgroundCheck': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    customerId: '客户',
    submitterId: '发起人',
    status: '状态',
    statuses: {
      pending: '待处理',
      processing: '处理中',
      completed: '已完成',
      failed: '失败',
    },
    completedAt: '完成时间',
    submitter: '发起人',
    startedAt: '开始时间',
    errorMessage: '错误信息',
    result: '背调结果',
  },
  'jushuitanShop': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    shopId: '店铺ID',
    shopName: '名称',
    shopType: '店铺类型',
    shopTypes: {
      online: '线上店铺',
      offline: '线下店铺',
    },
  },
  'jushuitanOrder': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    oId: '内部单号',
    soId: '线上单号',
    shopId: 'Shop',
    status: '状态',
    modified: 'Modified',
    key: 'Key',
    created: '创建时间',
    amount: '金额',
    customer: '客户',
    user: '归属业务员',
    userId: '归属业务员',
    customerId: '客户',
    payAmount: '应付金额',
    shopName: '店铺名称',
    shopSite: '店铺站点信息',
    items: '商品',
    freight: '运费',
    logisticsCompany: 'Logistics company',
    remark: '备注',
    buyerMessage: '买家留言',
    shopBuyerId: 'Shop buyer',
    freeAmount: '优惠金额',
    sentAt: '发货日期',
    paidAmount: '实付金额',
    orderDate: '下单时间',
    shop: '店铺',
    canEditKey: 'Can edit key',
    canBindCustomer: 'Can bind customer',
    canUnbindCustomer: 'Can unbind customer',
    receivableAmount: '应收金额',
    receivedAmount: '已收金额',
    isEven: '是否账平',
    realFreight: '实际运费',
    lId: '快递单号',
    outAmount: '出货金额',
    receiveIgnored: 'Receive ignored',
  },
  'jushuitanAfterSale': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    asId: '售后单号',
    outerAsId: '平台退货退款单号',
    soId: '线上单号',
    status: '状态',
    modified: '修改时间',
    created: '创建时间',
    refund: '退款金额',
    realRefund: '实退金额',
    receivableAmount: '应收金额',
    receivedAmount: '已收金额',
    order: '聚水潭订单',
    shop: '店铺',
    payment: '补偿金额',
    items: '商品',
    confirmDate: '确认日期',
  },
  'notification': {
    id: 'ID',
    createdAt: '通知时间',
    updatedAt: '更新时间',
    actorType: 'Actor type',
    actorId: 'Actor',
    targetType: 'Target type',
    targetId: 'Target',
    kind: '类型',
    kinds: {
      pick_customer: '客户被领取',
      release_customer: '客户被释放',
      assign_customer: '客户转接',
      pool_assign_customer: '公海客户分配',
      apply_assign_customer: '申请转接客户',
      cancel_apply_assign_customer: '取消申请转接客户',
      approve_assign_customer: '同意转接客户',
      reject_assign_customer: '拒绝转接客户',
      fill_customer_info_remind: '客户信息补录提醒',
      follow_customer_remind: '客户跟进提醒',
      memo_remind: '备忘提醒',
      follow_customers_remind: '客户跟进合并提醒',
      update_approved_payment: '收款单被修改',
      cancel_finished_sales_order: '销售订单被取消完结',
      payment_remind: '收款提醒',
      customer_pool_opening: '流转池开放',
      customer_claim_followup_due: '认领跟进即将到期',
      customer_capacity_warning: '客户容量预警',
      customer_claim_timeout_returned: '认领超时退回',
      customer_release_warning: '客户流转预警',
    },
    isRead: '是否已读',
    actor: 'Actor',
    target: 'Target',
    extra: 'Extra',
  },
  'memo': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    content: '备忘内容',
    remindAt: '提醒时间',
    customerId: '客户',
    isReminded: '是否已提醒',
    customer: '客户',
  },
  'customReport': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    targetType: '统计维度',
    kind: '类型',
    kinds: {
      monthly: '月度',
      weekly: '周度',
      daily: 'Daily',
    },
    targetId: 'Target',
    startAt: '开始时间',
    endAt: '结束时间',
    ownerType: 'Owner type',
    ownerId: 'Owner',
    data: '数据',
    target: '统计目标',
    owner: '所有者',
  },
  'task': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    creatorId: '创建者',
    title: '标题',
    content: '内容',
    filters: '筛选条件',
    displayFilters: '筛选条件',
    creator: '创建者',
    taskAssignments: '任务安排',
    assigneeIds: '执行人',
    customersCount: 'Customers count',
    followedCustomersCount: 'Followed customers count',
    followRatio: '触达率',
  },
  'jushuitanInventoryOut': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    soId: '线上单号',
    status: '状态',
    ioId: '出库单号',
    oId: 'O',
    shopId: 'Shop',
    modified: '修改时间',
    order: '聚水潭订单',
    shop: '店铺',
    kind: '类型',
    kinds: {
      sync: '同步',
      custom: '自定义',
    },
    orderType: '订单类型',
    payAmount: '应付金额',
    ioDate: '出库时间',
    paidAmount: '实付金额',
    freeAmount: '优惠金额',
    freight: '运费',
    items: '商品',
    payDate: '付款日期',
    logisticsCompany: '物流公司',
    lId: '物流单号',
  },
  'paymentAccount': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    code: '代码',
    position: '优先级',
    state: '状态',
    states: {
      active: '生效',
      inactive: '失效',
    },
    remark: '备注',
    canDestroy: 'Can destroy',
    taxRate: '税率',
  },
  'paymentAllocation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    paymentId: '收款明细',
    payableId: '关联对象',
    payableType: '关联对象类型',
    amount: '金额',
    payment: '收款明细',
    payable: '关联对象',
  },
  'payment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    paymentAccountId: '收款账号',
    number: '收款单号',
    serialNumber: '流水号',
    amount: '金额',
    auditorId: '审核者',
    creatorId: '创建者',
    customerId: '客户',
    kind: '类型',
    kinds: {
      deposit: '订金',
      payment: '货款',
    },
    state: '状态',
    states: {
      pending: '待审核',
      approved: '已审核',
      rejected: '已拒绝',
    },
    paidOn: '付款日期',
    image: '图片',
    paymentAccount: '收款账号',
    auditor: '审核者',
    creator: '创建者',
    customer: '客户',
    paymentAllocations: '金额分配',
    unallocatedAmount: '未分配金额',
    isEven: '是否账平',
    remark: '备注',
  },
  'adjustment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    adjustableType: '调整对象类型',
    amount: '金额',
    adjustableId: '调整对象ID',
    creatorId: '创建者',
    remark: '备注',
    adjustable: '销售订单',
    creator: '创建者',
  },
  'paymentReminder': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    salesOrderId: '销售订单',
    salesOrder: '销售订单',
    stageIndex: '阶段',
    percentage: '百分比',
    amount: '金额',
    date: '日期',
    state: '状态',
    states: {
      pending: '待收款',
      received: '已收款',
      overdue: '已逾期',
    },
    daysUntilDue: '距到期天数',
    lastNotifiedAt: '最后通知时间',
  },
  'salesLineItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    salesOrderId: 'Sales order',
    styleNumber: '款号',
    cost: '成本',
    costPrice: 'Cost price',
    price: '单价',
    quantity: '数量',
    fullyShipped: 'Fully shipped',
    shippedInfo: 'Shipped info',
  },
  'salesOrderAllocation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    sourceId: 'Source',
    targetId: 'Target',
    amount: '金额',
    allocatedOn: '分配日期',
    source: '售后销售订单',
    target: '非销售订单',
  },
  'afterSaleAllocation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    salesOrderId: 'Sales order',
    jushuitanAfterSaleId: 'Jushuitan after sale',
    receivedAmount: '已收金额',
    salesOrder: '销售订单',
    jushuitanAfterSale: '聚水潭售后',
  },
  'salesOrder': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    number: '单号',
    customerId: '客户',
    kind: '类型',
    kinds: {
      sample: '样板',
      bulk: '大货',
      after_sale: '售后&退货',
    },
    userId: 'User',
    isTransferExisting: '是否调拨现货',
    orderedOn: '下单日期',
    productType: '产品类型',
    productTypes: {
      custom: '定制',
      stock: '现货',
    },
    businessKind: '业务类型',
    businessKinds: {
      custom: '定制',
      wholesale: '批发',
    },
    sourceId: 'Source',
    salesAmount: '销售金额',
    customer: '客户',
    user: '用户',
    source: 'Source',
    paymentReminders: 'Payment reminders',
    salesLineItems: '销售订单商品',
    jushuitanOrderIds: '聚水潭订单',
    jushuitanOrders: '聚水潭订单',
    tax: '税额',
    cost: '成本',
    profit: '毛利',
    fullyShipped: '是否完全出货',
    sentJushuitanOrders: 'Sent jushuitan orders',
    jushuitanOrdersAmount: '聚水潭订单金额',
    jushuitanOrdersRealFreight: '聚水潭订单运费',
    confirmedJushuitanAfterSales: 'Confirmed jushuitan after sales',
    jushuitanAfterSalesAmount: '聚水潭售后退款金额',
    adjustments: 'Adjustments',
    adjustmentsAmount: '调整金额',
    remainingAmount: '订单余额',
    receivableAmount: '应收金额',
    unreceivedReceivableAmount: 'Unreceived receivable amount',
    paymentAllocations: 'Payment allocations',
    paymentAllocationsFromJushuitanOrders: 'Payment allocations from jushuitan orders',
    receivedAmount: '已收金额',
    isEven: '是否账平',
    finishedOn: '完结日期',
    remark: '备注',
    salesOrderAllocationsAmount: 'Sales order allocations amount',
    salesOrderAllocationsAsSource: 'Sales order allocations as source',
    salesOrderAllocationsAsTarget: 'Sales order allocations as target',
    afterSaleAllocations: '售后已收金额分配',
  },
  'feige/product': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    styleNumber: 'Style number',
    salesPrice: 'Sales price',
    minOrderQty: 'Min order qty',
  },
  'workReport': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    userId: 'User',
    date: '日期',
    content: '今日内容',
    plan: '明日计划',
    inquiryContent: '询盘内容',
    files: '附件',
    user: '用户',
    followRecords: '跟进记录',
  },
  'reports/receivable': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    shopNames: 'Shop names',
    shopBuyerId: 'Shop buyer',
    userScreenName: 'User screen name',
    isEven: 'Is even',
    overdue: 'Overdue',
    overdueAmount: 'Overdue amount',
    receivedAmount: 'Received amount',
    receivableAmount: 'Receivable amount',
    unreceivedReceivableAmount: 'Unreceived receivable amount',
    latestBillSendRecordSentAt: 'Latest bill send record sent at',
    latestBillSendRecordConfirmedAt: 'Latest bill send record confirmed at',
  },
  'reports/commissionSource': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: 'Screen name',
    afterSaleSalesOrderAmount: 'After sale sales order amount',
    receivedAmount: 'Received amount',
    receivableAmount: 'Receivable amount',
    tax: 'Tax',
    freight: 'Freight',
    cost: 'Cost',
    profit: 'Profit',
    salesOrders: 'Sales orders',
  },
  'performanceGoal': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    finishTarget: '完结目标',
    salesTarget: '开单目标',
    shippingTarget: '出货目标',
    creatorId: 'Creator',
    userId: 'User',
    startOn: '开始日期',
    goalType: '目标类型',
    goalTypes: {
      monthly: '月度',
      weekly: '周度',
      half_yearly: '半年度',
    },
    user: '业务员',
    creator: '创建者',
  },
  'team': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      normal: 'Normal',
      purple: 'Purple',
      golden: 'Golden',
    },
    color: 'Color',
    leader: 'Leader',
    merchandiser: 'Merchandiser',
    parent: 'Parent',
    teamMembers: 'Team members',
    childrenCount: 'Children count',
    children: 'Children',
  },
  'operationLog': {
    id: 'ID',
    createdAt: '操作时间',
    updatedAt: '更新时间',
    event: '事件',
    operatorType: 'Operator type',
    targetType: 'Target type',
    operatorId: 'Operator',
    targetId: 'Target',
    data: '操作数据',
    operator: '操作者',
    target: '操作对象',
  },
  'billSendRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    customerId: '客户',
    senderId: 'Sender',
    sendMethod: '发送方式',
    sentAt: '发送时间',
    state: '状态',
    states: {
      pending: '待确认',
      confirmed: '已确认',
    },
    customer: '客户',
    sender: '发送人',
    confirmedAt: '确认时间',
    confirmedBy: '确认人',
    confirmedIp: '确认IP',
    file: '确认凭证',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      event: '事件',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    publishedAt: '最后发布时间',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'hotWord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
    application: '应用管理',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    publishedAt: '发布时间',
    wxacode: '小程序码',
    content: '内容',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    email: '邮箱',
    phone: '手机号码',
    gender: '性别',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'roleCore/role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    customPermissions: 'Custom permissions',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
  'userGroup': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    performanceGoalTargets: 'Performance goal targets',
  },
}
